import React from 'react';
import { Link } from 'react-router-dom';
import ExternalLink from '../common/ExternalLink';

const LeetCodeHelpModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-3xl mx-4">
        <h2 className="text-xl font-semibold mb-6 text-center">
          How do I complete a Leetcode task?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Column - Video */}
          <div className="space-y-4">
            <h3 className="font-medium text-center">Watch this 1 min guide:</h3>
            <div className="relative w-full max-w-sm mx-auto" style={{ paddingBottom: '177.73%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/GmkMWiUUSSw?autoplay=1&mute=1"
                title="How to do Leetcode"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
          </div>
          {/* Right Column - Text Content */}
          <div className="space-y-6 text-gray-700 flex flex-col items-center justify-center">
            <div className="max-w-md">
              <p className="">
                Finish the{' '}
                <Link to="/lesson/leetcode" className="text-blue-600 hover:text-blue-800">
                  Leetcode lesson
                </Link>{' '}
                on the Lesson Tree if you don't know what Leetcode is!
              </p>

              <div className="mt-6">
                <p className="font-medium mb-3">5 steps to complete a Leetcode task:</p>
                <ol className="list-decimal list-inside space-y-2">
                  <li>
                    Make an account on{' '}
                    <ExternalLink
                      href="https://leetcode.com"
                      className="text-blue-600 hover:text-blue-800"
                    >
                      Leetcode.com
                    </ExternalLink>{' '}
                    and sign in
                  </li>

                  <li>
                    Choose a list of problems to follow for the next few months (
                    <ExternalLink
                      href="https://leetcode.com/studyplan/top-interview-150/"
                      className="text-blue-600 hover:text-blue-800"
                    >
                      Leetcode 150
                    </ExternalLink>{' '}
                    or{' '}
                    <ExternalLink
                      href="https://leetcode.com/studyplan/leetcode-75/"
                      className="text-blue-600 hover:text-blue-800"
                    >
                      Leetcode 75
                    </ExternalLink>{' '}
                    if you have fewer than 5hr a week)
                  </li>
                  <li>
                    Choose the first 'Easy' problem from the list top-down (if you're done with
                    Easy, go to Medium)
                  </li>
                  <li>
                    Attempt the problem! If you need help, consult Youtube tutorials, online
                    solutions, or practice with our{' '}
                    <Link to="/technical" className="text-blue-600 hover:text-blue-800">
                      AI interviewer in the Technical Prep tab
                    </Link>
                  </li>
                  <li>Pass all the test cases and you're done!</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeetCodeHelpModal;
